import { forwardRef } from 'react';
import { Box } from '@mui/material';

import { isProd } from '../../utils/config';

const Logo = forwardRef<HTMLImageElement>(() => {
	const src = isProd ? '/assets/ausrehab-logo.png' : '/assets/ausrehab-logo-dev.png';

	const logo = (
		<Box
			component="img"
			alt="ausrehab"
			src={src}
			sx={{
				width: 239,
				height: 'auto',
				maxWidth: '100%',
			}}
		/>
	);

	return <>{logo}</>;
});

export default Logo;
